import { Input as BaseInput, type InputProps } from "@heroui/react";

import { OpenMode } from "@onesolution/components";
import { useFieldContext, useLanguage } from "@onesolution/hooks";

export function Input(props: InputProps) {
	const field = useFieldContext<string>();
	const mode = field.form.state.values.formOpenMode as OpenMode;
	const { t } = useLanguage();
	if (mode === OpenMode.details)
		return (
			<div className="flex flex-col gap-2">
				{props.label ? (
					<h6 className="text-foreground-500">{props.label}</h6>
				) : null}
				<p>{field.state.value}</p>
			</div>
		);

	return (
		<BaseInput
			isInvalid={!field.state.meta.isValid}
			labelPlacement="outside-top"
			id={field.name}
			name={field.name}
			aria-label="text"
			value={field.state.value}
			onBlur={field.handleBlur}
			errorMessage={t("message.error")}
			onChange={(e) => field.handleChange(e.target.value)}
			{...props}
		/>
	);
}
